<button class="button button-primary-outline button-icon button-icon-left button-winona" (click)="event(click, item);">
    <ng-content></ng-content>
</button>